import React from 'react';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#060918] text-white py-12 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src="/logo-transparent.png"
              alt="Chill Point Logo"
              className="h-10 w-auto mb-4"
            />
            <p className="text-gray-500 text-sm">
              Professional air conditioning and refrigeration services in Ballito.
            </p>
          </div>
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-[#00D9FF] mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              {['AC Servicing', 'AC Repairs', 'Fridge Repairs', 'Installation'].map((item) => (
                <li key={item}>
                  <a href="#services" className="hover:text-white transition-colors">{item}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-[#00D9FF] mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              {[['About Us', '#about'], ['Testimonials', '#testimonials'], ['FAQ', '#faq'], ['Contact', '#contact']].map(([label, href]) => (
                <li key={label}>
                  <a href={href} className="hover:text-white transition-colors">{label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-[#00D9FF] mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>064 450 5026</li>
              <li>chillpointexec@gmail.com</li>
              <li>Ballito, North Coast</li>
              <li>KwaZulu-Natal</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/5 pt-8 text-center text-gray-500 text-sm">
          <div className="flex justify-center space-x-6 mb-4">
            <a href="/privacy-policy" className="hover:text-[#00D9FF] transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="hover:text-[#00D9FF] transition-colors">Terms of Service</a>
          </div>
          <p>&copy; {new Date().getFullYear()} Chill Point. All rights reserved. Professional HVAC & Refrigeration Services.</p>
        </div>
      </div>
    </footer>
  );
};
